<template>
  <div class="card-list">
    <global-loading v-if="$store.state.kpiStore.ssi_count_loading" />
    <div class="card-info" @click="changeContent('total_po')">
      <div class="card-head">
        Total PO
      </div>
      <div class="card-head">
        {{ ssiCount.total_po }}
      </div>
    </div>
    <div class="card-info" @click="changeContent('total_po_amount')">
      <div class="card-head">
        Total PO Amount
      </div>
      <div class="card-head">
        {{ curencyDelimiter(ssiCount.total_value_idr) }}
      </div>
    </div>

    <div class="card-info" @click="changeContent('top_vendor')">
      <div class="card-head">
        Top 10 Vendor PO Amount
      </div>
      <div class="card-head">
        {{ curencyDelimiter(ssiCount.total_vendor_po) }}
      </div>
    </div>
    <div class="card-info" @click="changeContent('user_confirmation')">
      <div class="card-head">
        User Confirmation
      </div>
      <div class="card-head">
        {{ userConfirmCalc(ssiCount.total_user_confirm) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  computed: {
    ssiCount() {
      const data = this.$store.state.kpiStore.ssiCount

      return data
    },
  },
  methods: {
    changeContent(content) {
      this.$emit('changeContent', content)
    },
    userConfirmCalc(data) {
      let confirm = 0
      let total = 0

      if (data && data.length > 0) {
        for (let value of data) {
          if (value.status == 'confirm') {
            confirm += value.jumlah
          }
          total += value.jumlah
        }

        return `${confirm} / ${total}`
      } else {
        return '0 / 0'
      }
    },
  },
}
</script>
<style scoped>
.card-list {
  width: 100%;
  /* padding-right: 2rem; */
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-info {
  height: 86px;
  padding: 12px 14px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--base-white, #fff);

  /* Shadow/xs */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  box-shadow: -6px 5px 8px 0 rgba(0, 0, 0, 0.2);
}

.card-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;

  cursor: pointer;
  background-color: white;
  /* height: 6rem; */
  /* text-align: center; */
  /* font-size: 0.8rem; */
  /* border: 1px solid red; */
}

.card-body {
  /* display: flex;
    flex-direction: column;
    flex: 1 0 0;
    align-self: stretch; */

  color: var(--gray-500, #667085);

  /* font-size: 14px; */
  font-style: normal;
  font-weight: 600;
  /* line-height: 24px; */

  /* font-size: 1.5rem;
    font-weight: 600;
    color: gray; */
}
</style>
